import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import moment from 'moment';

import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import TableComponent from 'UiKit/table-component';

import tableList from 'View/brief-live/section/prize-list/const';
import { useBriefLiveState } from 'View/brief-live/state';
import { modalPrizeListText } from 'Const/brief-live/view';

import styles from './styles.module.css';

const PrizeListModal = () => {
  const { state, updateState, filterState } = useBriefLiveState();

  const handleCloseModal = () => {
    updateState({ isOpenModalPrizeList: false, prizeListData: null });
  };

  const handleOpenPreview = (images) => {
    updateState({
      isOpenImagePreview: true,
      selectedImagePreview: images,
      isOpenModalPrizeList: false,
      imagePreviewPreviousModal: 'isOpenModalPrizeList',
    });
  };

  return (
    <Modal isOpen={state?.isOpenModalPrizeList} onClose={handleCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={'800px'} maxHeight={'660px'}>
        <ModalHeader>
          <TextBold className={styles['modal__text--title']}>{modalPrizeListText?.title}</TextBold>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className={styles['modal__section--content']}>
          <Box className={styles['modal__section--giveaway']}>
            <Box className={styles['modal__section--giveaway-info']}>
              <TextSemiBold className={styles['modal__text--giveaway-name']}>{state?.prizeListData?.title}</TextSemiBold>
              <Box className={styles['modal__row--giveaway']}>
                <Box className={styles['modal__column--brand']}>
                  <TextRegular className={styles['modal__text--label']}>{modalPrizeListText?.brand}</TextRegular>
                  <TextMedium className={styles['modal__text--value']}>{filterState?.brand?.label || '-'}</TextMedium>
                </Box>
                <Box className={styles['modal__column--createdAt']}>
                  <TextRegular className={styles['modal__text--label']}>{modalPrizeListText?.createdAt}</TextRegular>
                  <TextMedium className={styles['modal__text--value']}>
                    {state?.prizeListData?.createdAt ? moment(state.prizeListData.createdAt).format('DD MMMM YYYY | HH:mm') : '-'}
                  </TextMedium>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={styles['modal__section--giveaway-list']}>
            <TableComponent
              columns={tableList(handleOpenPreview)}
              dataSource={state?.prizeListData?.giveaways}
              isDataExist={state?.prizeListData?.giveaways?.length > 0}
              maxTableBodyHeight="384px"
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PrizeListModal;
